import { createSlice } from '@reduxjs/toolkit';
import {userLoginApi} from '../LoginApi/loginApi';

const userLoginSlice = createSlice({
  name: 'userLogin',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Handle fetchCommunityData cases
      .addCase(userLoginApi.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(userLoginApi.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(userLoginApi.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
  },
});

export default userLoginSlice.reducer;
